const DateFormat = (props) => {
  if (props.value !== null && props.value !== '' && props.value !== undefined) {
    const format = process.env.REACT_APP_DATE_FORMAT || 'DD/MM/YYYY, hh:mm A'

    // In case the backend sends a raw string without a timezone (like "2026-06-29 13:00:00"),
    // replacing the space with 'T' and appending 'Z' forces JS to treat it strictly as UTC.
    // If your backend already sends ISO strings (e.g., "...T13:00:00Z"), this is safe to skip,
    // but doing this prevents iOS/Safari parsing bugs.
    const safeDateString =
      String(props.value).replace(' ', 'T') + (String(props.value).endsWith('Z') ? '' : 'Z')
    const d = new Date(safeDateString)

    const pad = (n) => String(n).padStart(2, '0')

    // Use getUTC* methods to extract the raw database time, preventing the +5:30 IST addition
    const map = {
      YYYY: d.getUTCFullYear(),
      MM: pad(d.getUTCMonth() + 1),
      DD: pad(d.getUTCDate()),
      hh: pad(((d.getUTCHours() + 11) % 12) + 1), // 12-hour
      HH: pad(d.getUTCHours()), // 24-hour
      mm: pad(d.getUTCMinutes()),
      A: d.getUTCHours() >= 12 ? 'PM' : 'AM'
    }

    let result = format

    Object.keys(map).forEach((key) => {
      result = result.replace(key, map[key])
    })

    return result
  } else {
    return ''
  }
}

export default DateFormat
